import Bookmarks from '@components/Icons/Bookmarks';
import ChatsCircle from '@components/Icons/ChatsCircle';
import Book from '@components/Icons/Book';
import UsersThree from '@components/Icons/UsersThree';
import CalendarBlank from '@components/Icons/CalendarBlank';
import Package from '@components/Icons/Package';
import Activity from '@components/Icons/Activity';

const ALL_TABS = [
  {
    icon: ChatsCircle,
    id: 'chat',
    label: 'Chat',
  },
  {
    icon: Book,
    id: 'library',
    label: 'Library',
  },
  {
    icon: Package,
    id: 'services',
    label: 'Services',
  },
  {
    icon: Bookmarks,
    id: 'bookmarks',
    label: 'Bookmarks',
  },
  {
    icon: UsersThree,
    id: 'community',
    label: 'Community',
  },
  {
    icon: CalendarBlank,
    id: 'bookings',
    label: 'Bookings',
  },
  {
    icon: Activity,
    id: 'activity',
    label: 'Activity',
  },
];

export default ALL_TABS;